import firebase from "../../../firebase";

var storage = firebase.app().storage("gs://zz-security.appspot.com");

class FirebaseStorage {

  upload(key, file) {
    var metadata = {
      contentType: 'image/jpeg'
    };

    var storageRef = firebase.storage().ref();
    var f = Date.now()
    let fileloc = "Images/"
    if(localStorage.userId){
      fileloc = localStorage.userId+"/Images/"
    }
    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = storageRef.child(fileloc+key+'/'+f+"-"+ file.name).put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      },
      function (error) {

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;

          case 'storage/canceled':
            // User canceled the upload
            break;



          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
      },
      function () {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);

          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1; //January is 0!
          var min = today.getMinutes();
          var ss = today.getSeconds();
          var hh = today.getHours();
          var yyyy = today.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
          if (mm < 10) {
            mm = '0' + mm;
          }
          var currentDT = yyyy + "-" + mm + "-" + dd + "-" + hh + "-" + min;
          localStorage.setItem("uploadedimage",downloadURL)
          alert(downloadURL);

        });
      });

    return true;
  }

}

export default new FirebaseStorage();
